import Input from 'components/Form/fields/Input';
import Hidden from 'components/Form/fields/Hidden';
import Upload from 'components/Form/fields/Upload';
import Slider from 'components/Form/fields/Slider';
import Select from 'components/Form/fields/Select';
import ColorList from 'components/Form/fields/ColorList';
import Textarea from 'components/Form/fields/Textarea';

const useFields = (inputs, methods) => {

	const getPropsComponant = (ps) => {
		return {
			...ps,
			...methods
		}
	}
	//change to dynamic...
	const fields = {
		colorlist: (props) => {
			return (
				<ColorList
					{...getPropsComponant(props)}
				/>
			);
		},
		select: (props) => {
			return (
				<Select
					{...getPropsComponant(props)}
				/>
			);
		},
		textarea: (props) => {
			return (
				<Textarea
					{...getPropsComponant(props)}
				/>
			);
		},
		input: (props) => {
			return (
				<Input
					{...getPropsComponant(props)}
				/>
			);
		},
		hidden: (props) => {
			return (
				<Hidden
					{...getPropsComponant(props)}
				/>
			);
		},
		upload: (props) => {
			return (
				<Upload
					{...getPropsComponant(props)}
				/>
			);
		},
		slider: (props) => {
			return (
				<Slider
					{...getPropsComponant(props)}
				/>
			);
		}
	}

	return {
		fields
	};
};

export default useFields;
